<template>
    <div class="count-container standard">
        <div class="bed-count clearfix" v-if="countInfo.bedrooms">
            <p class="count-logo iconfont icon-bed"></p>
            <p>
                <span class="number">{{
                    countInfo.bedrooms.num
                }}</span>
                <span class="house">{{ countInfo.bedrooms.unit }}</span>
            </p>
        </div>
        <div class="bath-count clearfix" v-if="countInfo.bathrooms">
            <p class="count-logo iconfont icon-bath"></p>
            <p>
                <span class="number">{{
                    countInfo.bathrooms.num
                }}</span>
                <span class="house">{{
                    countInfo.bathrooms.unit
                }}</span>
            </p>
        </div>
        <div
            class="sqft-count clearfix"
            v-if="countInfo.sqft"
        >
            <p class="count-logo iconfont icon-sqft"></p>
            <p>
                <span class="number">{{
                    countInfo.sqft.num
                }}</span>
                <span class="house">{{
                    countInfo.sqft.unit
                }}</span>
            </p>
        </div>
    </div>
</template>
<script>
import { mapState } from '@/store/helpers';
import { getCountObj } from '../../info-header-count.js';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['filling'],
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        countInfo({ info }) {
            return getCountObj.call(this, info);
        }
    }
};
</script>
<style lang="scss">
.count-container.standard {
    div {
        display: inline-flex;
        margin-right: 20px;
        &.sqft-count {
            margin-right: 0px;
        }
        > p {
            > span {
                display: block;
            }
            &.count-logo {
                width: 36px;
                height: 36px;
                border: 1px solid #e2e2e2;
                border-radius: 50%;
                position: relative;
                margin-right: 8px;
            }
            &.icon-bed,
            &.icon-bath,
            &.icon-sqft {
                font-size: 14px;
                &:before {
                    color: var(--color-disable);
                    position: absolute;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    left: 50%;
                }
            }
            .number {
                font-size: 20px;
                font-family: var(--font-bold);
                line-height: 110%;
                color: var(--color-text);
            }
            .house {
                font-size: 12px;
                color: var(--color-disable);
                line-height: 120%;
                padding-top: 2px;
            }
        }
    }
}
@media (max-width: 600px) {
    .count-container.standard {
        float: none;
        display: flex;
        border-top: solid 1px #f4f5f8;
        border-bottom: solid 1px #f4f5f8;
        margin: 10px 0 30px 0;
        padding: 13px 0;
        font-size: 0; // remove the gap
        div {
            flex: 1;
            margin: 0;
            padding: 0 20px;
            &.bed-count {
                padding-bottom: 0;
            }
            &.bed-count,
            &.bath-count {
                border-right: solid 1px #e2e4ea;
            }
            > p {
                &.count-logo {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
                .number {
                    font-size: 14px;
                }
                .house {
                    padding-top: 0px;
                }
            }
        }
    }
}
</style>
